import React, { useState } from 'react';
import LiteHeader from './LiteHeader';
// LITE_SIDEBAR_WIDTH (230, exported by LiteSidebar) is mirrored in the
// `md:pl-[230px]` class below — Tailwind's arbitrary-value syntax needs a
// literal, so keep the two in sync by hand if the rail width ever changes.
import LiteSidebar from './LiteSidebar';
import MobileNavDrawer from './MobileNavDrawer';

// Minimal app shell for the free-tier journey: fixed header + fixed slim
// sidebar + scrollable content. Deliberately independent of the real
// AppLayout/NavSidebar (which are org-type and permission driven).
//
// Q5 (S7 fix batch 3, D32): below `md`, LiteSidebar's fixed rail is hidden
// (it used to stay at its full ~230px width regardless of viewport,
// crushing main content — body scrollWidth 644 at 390px) and `main` gives
// back the space it used to reserve for it (`md:pl-[230px]`, replacing
// the old unconditional inline `paddingLeft`). No explicit `pl-0` base: in
// this app's bundled CSS order `.pl-0` lands after the md media query and
// overrides it, leaving desktop content underneath the fixed rail —
// padding already defaults to 0. The only way to reach the nav
// below `md` is the header's hamburger → MobileNavDrawer, an overlay reusing
// the exact same nav content.
export default function LiteShell({ children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-secondaryColor-lightest">
      <LiteHeader onMenuClick={() => setMobileNavOpen(true)} />
      <LiteSidebar />
      <MobileNavDrawer
        open={mobileNavOpen}
        onOpenChange={setMobileNavOpen}
      />
      <main className="pt-14 min-h-screen md:pl-[230px]">
        <div className="px-4 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">{children}</div>
      </main>
    </div>
  );
}
